// Hand work to the worker when there is one, do it here when there is not.
// GPL-3.0-or-later.
let worker: Worker | null | undefined; // undefined = not tried yet, null = unavailable
const pending = new Map<number, { ok: (r: any) => void; fail: (e: any) => void }>(); // eslint-disable-line @typescript-eslint/no-explicit-any
let seq = 0;

function get(): Worker | null {
  if (worker !== undefined) return worker;
  try {
    if (typeof Worker === "undefined") { worker = null; return null; }
    const w = new Worker(new URL("./worker.ts", import.meta.url), { type: "module" });
    w.onmessage = (e) => { const p = pending.get(e.data.id); pending.delete(e.data.id); if (!p) return; e.data.error ? p.fail(e.data.error) : p.ok(e.data.result); };
    w.onerror = () => { // the worker died: fail what is queued, compute here from now on
      pending.forEach((p) => p.fail("worker error")); pending.clear(); worker = null; };
    worker = w;
  } catch { worker = null; }
  return worker;
}

/** Run `op` with `args` off the main thread; `inline` is the same computation done here,
 *  used when no worker exists or the worker fails. */
export function run<T>(op: "density" | "dse" | "combo" | "sens", args: unknown, inline: () => T): Promise<T> {
  const w = get();
  if (!w) return new Promise<T>((ok, fail) => { try { ok(inline()); } catch (e) { fail(e); } });
  const id = ++seq;
  return new Promise<T>((ok, fail) => { pending.set(id, { ok, fail }); w.postMessage({ id, op, args }); })
    .catch((e) => { try { console.warn("[dipfield-suite] worker job failed, computing inline:", e); } catch { /* no console */ } return inline(); });
}
export const hasWorker = () => !!get();
